/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import {
    object, array, string, func,
} from 'prop-types';
import { connect } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import withStyles from '@material-ui/core/styles/withStyles';
import configENV from '../../../config';

import SubscriptionSummary from './SubscriptionSummary';
import SubscriptionCancelDialog from './SubscriptionCancelDialog';

const { PERSIST_KEY } = configENV;

const styles = (theme) => ({
    card: {
        backgroundColor: '#fffff8',
        marginBottom: '20px',
        boxShadow: '0 3px 6px rgba(0,0,0,.16), 0 3px 6px rgba(0,0,0,.23)',
    },
    subLabel: {
        fontSize: '13px',
        fontWeight: 'bold',
    },
    subAttr: {
        fontSize: '12px',
    },
    itemDiv: {
        marginBottom: '6px',
    },
    primaryButtonStyle: {
        backgroundColor: theme.palette.primaryButton,
        color: theme.palette.white,
        fontSize: '14px',
        fontWeight: 'bold',
        width: '98%',
        borderRadius: '20px',
    },
    primaryButtonActive: {
        backgroundColor: theme.palette.primaryButton,
        color: theme.palette.white,
        fontSize: '14px',
        width: '98%',
    },
    btnPriWrapper: {
        textAlign: 'center',
        margin: '30px 0px',
    },
});

function subscriptionDuration(d) {
    const SUBSCRIPTION_DURATIONS = {
        '-1': 'Continue until I stop',
        3: 'Three months',
        6: 'Six months',
        12: 'Twelve months',
    };

    return SUBSCRIPTION_DURATIONS[d] ? SUBSCRIPTION_DURATIONS[d] : d;
}

function subscriptionInterval(i) {
    const SUBSCRIPTION_INTERVALS = {
        1: 'Every 1 week',
        4: 'Every 4 weeks',
        6: 'Every 6 weeks',
        8: 'Every 8 weeks',
        30: 'Monthly',
    };

    return SUBSCRIPTION_INTERVALS[i] ? SUBSCRIPTION_INTERVALS[i] : i;
}

function ShipmentHistory(shipmentHistory) {
    return (
        <div style={{ marginTop: '20px' }}>
            <h2>SHIPMENT HISTORY</h2>
            <table style={{ width: '100%' }}>
                <thead>
                    <tr>
                        <th style={{ width: '50%', textAlign: 'left' }}>Order #:</th>
                        <th style={{ width: '50%', textAlign: 'right' }}>Ship Date:</th>
                    </tr>
                </thead>
                <tbody>
                    {shipmentHistory.history.map((shipment) => (
                        <tr key={shipment.orderNumber}>
                            <td style={{ width: '50%', textAlign: 'left' }}>#{shipment.orderNumber}</td>
                            <td style={{ width: '50%', textAlign: 'right' }}>{shipment.shipDate}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

class SubscriptionDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cancelDialogOpen: false,
        };
    }

    handleCancelClick = () => {
        this.setState({ cancelDialogOpen: true });
    }

    handleCancelDialogClose = () => {
        this.setState({ cancelDialogOpen: false });
    }

    handleCancelConfirmed = () => {
        const { handleCancel } = this.props;
        this.setState({ cancelDialogOpen: false });
        handleCancel();
    }

    render() {
        const { subscriptions, subscriptionRuleId, classes } = this.props;
        const { cancelDialogOpen } = this.state;
        const currentSubscription = subscriptions.filter((subscription) => subscription.ruleId === subscriptionRuleId);
        if (currentSubscription.length === 1) {
            const subscription = currentSubscription[0];
            return (
                <Card className={classes.card}>
                    <CardContent>
                        <SubscriptionSummary subscription={subscription} />
                        <h2>SUBSCRIPTION DETAILS</h2>
                        <div className={classes.itemDiv}>
                            <span className={classes.subLabel}>Frequency: </span>
                            <span className={classes.subAttr}>{subscriptionInterval(subscription.interval)}</span>
                        </div>
                        <div className={classes.itemDiv}>
                            <span className={classes.subLabel}>Duration: </span>
                            <span className={classes.subAttr}>{subscriptionDuration(subscription.duration)}</span>
                        </div>
                        <div className={classes.itemDiv}>
                            <span className={classes.subLabel}>Start Date: </span>
                            <span className={classes.subAttr}>{subscription.startDate}</span>
                        </div>
                        <div className={classes.itemDiv}>
                            <span className={classes.subLabel}>End Date: </span>
                            <span className={classes.subAttr}>
                                {subscription.endDate === 'Indefinite' ? (<span />) : subscription.endDate}
                            </span>
                        </div>
                        {subscription.orderHistoryResult && subscription.orderHistoryResult.length > 0
                            && <ShipmentHistory history={subscription.orderHistoryResult} />}
                        {subscription.subscriptionStatus !== 'CANCELLED'
                            && (
                                <Grid className={classes.btnPriWrapper} item>
                                    <Button
                                        className={classes.primaryButtonStyle}
                                        variant="contained"
                                        align="center"
                                        raised="true"
                                        onClick={this.handleCancelClick}
                                    >
                                        Cancel this Subscription
                                    </Button>
                                </Grid>
                            )}
                        <SubscriptionCancelDialog open={cancelDialogOpen} onCancelClose={this.handleCancelDialogClose} onConfirmClose={this.handleCancelConfirmed} />
                    </CardContent>
                </Card>
            );
        }
        return null;
    }
}

SubscriptionDetail.propTypes = {
    subscriptionRuleId: string.isRequired,
    handleCancel: func.isRequired,
    subscriptions: array.isRequired,
    classes: object.isRequired,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        subscriptions: newState.subscriptions,
    };
};

export default connect(
    mapStateToProps,
    null,
)(withStyles(styles, { withTheme: true })(SubscriptionDetail));
